<template>
  <div>
    <div class="cat-name">用户增长统计</div>
    <div class="fil-view">
      <div
        :class="['sel-btn', actDay === 1 ? 'active' : '']"
        @click="dayChange(1)"
      >
        7日
      </div>
      <div
        :class="['sel-btn', actDay === 2 ? 'active' : '']"
        @click="dayChange(2)"
      >
        30日
      </div>
      <div>
        <el-form :inline="true" :model="filters" :size="size">
          <el-form-item class="m-l-14">
            <el-date-picker
              v-model="dateArea"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <butn
              btntype="primary"
              title="查询"
              @click.native="initData"
            ></butn>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="mar-30" id="grow-chart"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import moment from "moment";
import butn from "@/components/button/index";
import { findUserAddStatistics } from "@/api/user";

export default {
  props: ["deptId", "userType"],
  components: {
    butn,
  },
  watch: {
    deptId: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        if (this.userType === -1) {
          if (val) {
            this.qparas.deptId = val;
            this.query();
          }
        } else {
          this.qparas.deptId = val || "";
          this.query();
        }
      },
      immediate: true,
    },
  },

  data() {
    let that = this;
    return {
      size: "small",
      actDay: 1,
      nowDay: moment(new Date()).format("YYYY-MM-DD"),
      sevenDay: moment(new Date() - 144 * 60 * 60 * 1000).format("YYYY-MM-DD"),
      ssDay: moment(new Date() - 696 * 60 * 60 * 1000).format("YYYY-MM-DD"),
      filters: {},
      dateArea: [],
      pickerMinDate: null,
      listData: [],
      chartData: [],
      appCdata: [],
      webCdata: [],
      chart: null,
      pickerOptions1: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (that.pickerMinDate) {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = that.pickerMinDate + day30;
            let minTime = that.pickerMinDate - day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime;
          }

          return time.getTime() > Date.now();
        },
      },
      qparas: {
        deptId: "",
        start: null,
        end: null,
      },
    };
  },
  mounted() {
    this.drawChart(this.chartData);
  },
  methods: {
    drawChart(data) {
      const chart = new Chart({
        container: "grow-chart",
        autoFit: true,
        height: 300,
      });
      chart.data(data);
      chart.scale({
        date: {
          // range: [0, 1],
        },
        num: {
          min: 0,
          nice: true,
          tickInterval: 1,
        },
      });
      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      chart.axis("num");
      chart.legend(false);
      chart.line().position("date*num").color("type").shape("smooth");
      chart.point().position("date*num").color("type").shape("circle");
      chart.render();
      this.chart = chart;
    },
    dayChange(val) {
      this.actDay = val;
      this.query();
    },
    query() {
      switch (this.actDay) {
        case 1:
          this.qparas.start = this.sevenDay;
          this.qparas.end = this.nowDay;
          break;
        case 2:
          this.qparas.start = this.ssDay;
          this.qparas.end = this.nowDay;
          break;
        case 3:
          this.qparas.start = this.dateArea[0];
          this.qparas.end = this.dateArea[1];
          break;
        default:
          break;
      }
      findUserAddStatistics(this.qparas).then(({ code, data }) => {
        if (code === 0) {
          this.listData = data;
          this.chartData = data;
          this.changeChart(this.chartData);
        }
      });
    },
    changeChart(data) {
      this.chart.clear();
      this.chart.data(data);
      this.chart.scale({
        date: {},
        num: {
          min: 0,
          nice: true,
          tickInterval: 1,
        },
      });
      this.chart.tooltip({
        showCrosshairs: true,
        shared: false,
      });
      this.chart.axis("num");
      this.chart.legend(false);
      this.chart
        .line()
        .position("date*num")
        .color("type", () => {
          return "#3A85FF";
        })
        .shape("smooth");
      this.chart.area().position("date*num").shape("smooth");
      this.chart.render();
    },
    initData() {
      if (!this.dateArea || this.dateArea.length < 2) {
        this.$message.error("请选择日期范围！");
      } else {
        this.qparas.start = this.dateArea[0];
        this.qparas.end = this.dateArea[1];
        this.dayChange(3);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cat-name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #343c4a;
  padding: 30px 0 24px 0;
}
.fil-view {
  display: flex;
  .sel-btn {
    height: 28px;
    line-height: 28px;
    background: #ffffff;
    border: 1px solid #d7dbe0;
    padding: 0 26px;
    border-radius: 5px;
    margin-right: 8px;
    cursor: pointer;
    &.active {
      background: rgba(58, 133, 255, 0.21);
      border: 1px solid #3a85ff;
    }
  }
  .logo-tip {
    flex: 1;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    height: 35px;
    img {
      display: block;
      width: 40px;
      height: 8px;
    }
    .tip-char {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #51627d;
      margin-right: 24px;
      margin-left: 3px;
    }
  }
}
.table-view {
  display: flex;
  .fix-item {
    width: 140px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .top {
    background: #dce7fa;
    font-weight: 500;
    color: #343c4a;
  }
  .left {
  }
  .right {
    flex: 1;
    display: flex;
    overflow: auto;
  }
}
.mar-30 {
  margin: 30px 0;
}
</style>